import { useEffect, useLayoutEffect } from "react";

const REDIRECT_DELAY_MS = 5000;
const HAS_HTTP_SCHEME = /^https?:\/\//i;

// A host without a scheme, such as "www.site.com/thanks", would be treated as a relative path.
export const ensureHttpsRedirectUrl = (redirectUrl) => {
    if (typeof redirectUrl !== "string") {
        return "";
    }

    const trimmedUrl = redirectUrl.trim();
    if (!trimmedUrl || HAS_HTTP_SCHEME.test(trimmedUrl)) {
        return trimmedUrl;
    }

    return `https://${trimmedUrl}`;
};

// immediate is used when the destination page is already the thank-you page.
export const usePostSubmitRedirect = (success, redirectUrl, immediate = false) => {
    const destinationUrl = ensureHttpsRedirectUrl(redirectUrl);

    useLayoutEffect(() => {
        if (!immediate || !success || !destinationUrl) {
            return undefined;
        }

        window.location.href = destinationUrl;
        return undefined;
    }, [immediate, success, destinationUrl]);

    useEffect(() => {
        if (immediate || !success || !destinationUrl) {
            return undefined;
        }

        const timer = setTimeout(() => {
            window.location.href = destinationUrl;
        }, REDIRECT_DELAY_MS);

        return () => clearTimeout(timer);
    }, [immediate, success, destinationUrl]);
};
